const STORAGE_KEY = 'houdiny:onboarding-progress'

export const loadProgress = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export const saveProgress = snapshot => {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot))
    } catch {
        return
    }
}

export const clearProgress = () => {
    try {
        window.localStorage.removeItem(STORAGE_KEY)
    } catch {
        return
    }
}
